import Portfolio from "./SKPortfolio";

export default function App() {
  return <Portfolio />;
}
